<template>
  <div class="skin-diag-banner">
    <div class="skin-diag-banner__image">
      <img :src="banner.image" alt="bannerImage" class="lazyloaded" />
    </div>
    <div class="skin-diag-banner__title">
      <h2>
        <span class="heading-xxl">{{ banner.title }}</span>
        <span class="heading-xxl-em">{{ banner.subTitle }} </span>
      </h2>
    </div>
    <div class="skin-diag-banner__description">
      <p class="heading-md-em">{{ banner.description }}</p>
      <p class="heading-md mb-xl">{{ banner.subDescription }}</p>
      <span>
        <a
          :href="banner.ctaLink"
          class="skin-diag-banner__button ripple-animation ripple-animation--black"
        >
          {{ banner.ctaBtn }}
        </a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'skin-diag-invite',
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
};
</script>
